module.exports = __webpack_public_path__ + "static/img/select-img4.6ec6d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img4.png
// module id = wHee
// module chunks = 1